// Taki turu tespiti — Studio konsept sahnelerini bu ture gore suzer.
//
// Katalogta urun tipi ELLE secilebilir; secilmemisse ad uzerinden tahmin
// edilir. Tahmin KELIME bazlidir: duz substring aramasinda "earring" icinde
// "ring" gectigi icin kupeler yuzuk sayiliyordu. Ayni nedenle daha belirgin
// turler (kupe) once denenir.

export const JEWELRY_TYPE_KEYS = ["kolye", "kupe", "yuzuk", "bileklik", "halhal", "set"] as const;

export const JEWELRY_TYPE_LABELS: Record<string, string> = {
  kolye: "Kolye",
  kupe: "Küpe",
  yuzuk: "Yüzük",
  bileklik: "Bileklik",
  halhal: "Halhal",
  set: "Set",
};

// Sira onemli: ustteki tur once denenir ("kupe" mutlaka "yuzuk"ten once).
const TYPE_WORDS: Array<[string, string[]]> = [
  ["kupe", ["kupe", "küpe", "kupeler", "earring", "earrings", "stud", "studs", "huggie", "huggies", "hoop", "hoops"]],
  ["kolye", ["kolye", "necklace", "necklaces", "pendant", "pendants", "choker", "chokers"]],
  ["bileklik", ["bileklik", "bracelet", "bracelets", "bangle", "bangles"]],
  ["halhal", ["halhal", "anklet", "anklets"]],
  ["yuzuk", ["yuzuk", "yüzük", "ring", "rings"]],
  ["set", ["set", "sets", "takim", "takım"]],
];

/** Adi kelimelere ayirir — harf/rakam disindaki her sey ayirici sayilir. */
function words(name: string): Set<string> {
  return new Set(name.toLowerCase().split(/[^0-9a-zçğıöşü]+/i).filter(Boolean));
}

/** Urun adindan taki turunu tahmin et; eslesme yoksa null (suzme yapilmaz). */
export function guessJewelryType(name?: string): string | null {
  const n = (name ?? "").trim();
  if (!n) return null;
  const tokens = words(n);
  for (const [key, list] of TYPE_WORDS) {
    if (list.some((w) => tokens.has(w))) return key;
  }
  return null;
}

/** Urunun turu: katalogta elle secildiyse O gecerli, yoksa addan tahmin. */
export function productJewelryType(
  cat: { productTypeKey?: string | null; name?: string } | undefined | null,
): string | null {
  const manual = cat?.productTypeKey?.trim();
  if (manual) return manual;
  return guessJewelryType(cat?.name);
}
